export enum UserActivationStateId {
  SCORE = 'score',
  TRANSPORT_COMPANY = 'transportCompany',
  MANUAL = 'manual',
}
